import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_400.main : theme.palette.gray_50.main,
      borderRadius: '8px',
      height: 40,
      '& .MuiOutlinedInput-input': {
        color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
        '&.Mui-disabled': {
          cursor: 'pointer'
        }
      },
      '& .MuiSelect-outlined': {
        paddingTop: 10,
        paddingBottom: 10
      }
    },
    '& label': {
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main
    }
  },
  selectedText: {
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%'
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? theme.palette.dark_300?.main || '#3a3a4a' : theme.palette.gray_200?.main || '#e0e0e0'}`,
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main
  },
  searchInput: {
    flex: 1,
    fontSize: '14px'
  },
  menuPaper: {
    maxHeight: '300px'
  },
  checkbox: {
    marginRight: 8,
    padding: 0,
    color: theme.palette.type === 'dark'
      ? theme.palette.dark_50.main + '!important'
      : theme.palette.gray_400.main + '!important',
    '&.Mui-checked': {
      color: theme.palette.blue_300.main + '!important'
    },
    '& .MuiSvgIcon-root': {
      color: 'inherit'
    }
  }
}))
